export function saveAllAudiences(audiences) {
  return {
    type: 'AUDIENCE_LIST',
    audiences,
  };
}
